import React, { useState, useRef } from 'react';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import MapBackground from './components/MapBackground';
import IdentitiesPage from './pages/IdentitiesPage';
import LocationsPage from './pages/LocationsPage';
import ContactsPage from './pages/ContactsPage';
import SettingsPage from './pages/SettingsPage';
import { theme } from './constants/theme';
import { type Page, navigationItems } from './constants/navigation';

type CurrentPage = Page | null;

interface MapBackgroundRef {
  clearMarkers: () => void;
}

function App() {
  const [currentPage, setCurrentPage] = useState<CurrentPage>(null);
  const mapRef = useRef<MapBackgroundRef>(null);

  const handlePageChange = (page: CurrentPage) => {
    if (currentPage === page) {
      // Closing the current page
      setCurrentPage(null);
      mapRef.current?.clearMarkers();
    } else {
      setCurrentPage(page);
    }
  };

  return (
    <Box position="relative" height="100vh" width="100vw">
      <MapBackground ref={mapRef} />
      
      <Flex
        position="absolute"
        top={0}
        left={0}
        right={0}
        height="60px"
        bg={theme.colors.bg}
        borderBottom="1px solid"
        borderColor={theme.colors.border}
        alignItems="center"
        justifyContent="space-between"
        px={4}
        zIndex={1000}
      >
        <Text fontSize="xl" fontWeight="bold">
          Spotstr
        </Text>
        
        <Flex gap={2}>
          {navigationItems.map((item) => {
            const Icon = item.icon;
            return (
              <IconButton
                key={item.id}
                aria-label={item.label}
                onClick={() => handlePageChange(item.id)}
                colorPalette={currentPage === item.id ? 'blue' : 'gray'}
                variant={currentPage === item.id ? 'solid' : 'ghost'}
              >
                <Icon />
              </IconButton>
            );
          })}
        </Flex>
      </Flex>

      <Box
        position="absolute"
        top="60px"
        left={0}
        right={0}
        bottom={0}
        overflow="auto"
        zIndex={999}
        pointerEvents="none"
      >
        {currentPage && (
          <Box pointerEvents="auto">
            {currentPage === 'identities' && <IdentitiesPage />}
            {currentPage === 'locations' && <LocationsPage />}
            {currentPage === 'contacts' && <ContactsPage />}
            {currentPage === 'settings' && <SettingsPage />}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default App;